import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import './registerServiceWorker';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueTour from 'vue-tour';
import VueSession from 'vue-session';

import * as VueGoogleMaps from 'vue2-google-maps';
// You could use your own fancy-schmancy custom styles.
// We'll use the defaults here because we're lazy.
import 'vue-tour/dist/vue-tour.css';
import JsonCSV from 'vue-json-csv';
import { TokenService } from './services/storageService';
import ApiService from './services/apiService';
import store from './store/store';
import router from './router';
import App from './App.vue';
import './filter/filter';


import 'bootstrap-vue/dist/bootstrap-vue.css';

import VCalendar from 'v-calendar';

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDmb6M4jW8n78YCCgDaJ6PUf0uugA9WOzs',
    libraries: 'places', // necessary for places input
  },
});

const options = {
  persist: true,
};
Vue.use(VueSession, options);
Vue.component('downloadCsv', JsonCSV);
Vue.component('vue-multiselect', window.VueMultiselect.default);
Vue.use(VueTour);
Vue.use(CKEditor);

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API);

axios.interceptors.response.use((response) => {
  return response
}, function (error) {

  if (error.response.status === 401) {

    store.dispatch('destroyToken').then((response) => {
      Vue.prototype.$session.destroy();
      router.push({ name: 'login' });
    });
    return Promise.reject(error);
  }
  return Promise.reject(error);
});

axios.interceptors.request.use(
  (config) => {
    const token = Vue.prototype.$session.get('jwt');

    if (token) {
      config.headers.Authorization = `Bearer ${token.token}`;
    }

    return config;
  },

  error => Promise.reject(error),
);

if (TokenService.getToken()) {
}

Vue.use(VueSweetalert2);

Vue.use(VeeValidate, {
  // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'veeErrors',
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
});

Vue.use(BootstrapVue);

const equalDimensionsRule = {
  getMessage(field, [width, height], data) {
    return (data && data.message) || `The ${field} field must be ${width} by ${height}.`;
  },
  validate(files, [width, height]) {
    const validateImage = (file, width, height) => {
      const URL = window.URL || window.webkitURL;
      return new Promise((resolve) => {
        const image = new Image();
        image.onerror = () => resolve({ valid: false });
        image.onload = () => resolve({
          valid: (image.width == Number(width) && image.height == Number(height)), // only change from official rule
        });

        image.src = URL.createObjectURL(file);
      });
    };
    const list = [];
    for (let i = 0; i < files.length; i++) {
      // if file is not an image, reject.
      if (!/\.(jpg|svg|jpeg|png|bmp|gif|webp)$/i.test(files[i].name)) {
        return false;
      }
      list.push(files[i]);
    }
    return Promise.all(list.map(file => validateImage(file, width, height)));
  },
};

const minimalDimensionsRule = {
  getMessage(field, [width, height], data) {
    return (data && data.message) || `The ${field} field must be Minimal ${width} by ${height}.`;
  },
  validate(files, [width, height]) {
    const validateImage = (file, width, height) => {
      const URL = window.URL || window.webkitURL;
      return new Promise((resolve) => {
        const image = new Image();
        image.onerror = () => resolve({ valid: false });
        image.onload = () => resolve({
          valid: image.width >= Number(width) && image.height >= Number(height), // only change from official rule
        });

        image.src = URL.createObjectURL(file);
      });
    };
    const list = [];
    for (let i = 0; i < files.length; i++) {
      // if file is not an image, reject.
      if (!/\.(jpg|svg|jpeg|png|bmp|gif|webp)$/i.test(files[i].name)) {
        return false;
      }
      list.push(files[i]);
    }
    return Promise.all(list.map(file => validateImage(file, width, height)));
  },
};

const ratioDimensionsRule = {
  getMessage(field, [width, height], data) {
    return (data && data.message) || `The ${field} field have to use image ratio ${width} : ${height}.`;
  },
  validate(files, [width, height]) {
    const validateImage = (file, width, height) => {
      const URL = window.URL || window.webkitURL;
      return new Promise((resolve) => {
        const image = new Image();
        image.onerror = () => resolve({ valid: false });
        image.onload = () => resolve({
          valid: (image.width / image.height) == (Number(width) / Number(height)), // only change from official rule
        });

        image.src = URL.createObjectURL(file);
      });
    };
    const list = [];
    for (let i = 0; i < files.length; i++) {
      // if file is not an image, reject.
      if (!/\.(jpg|svg|jpeg|png|bmp|gif|webp)$/i.test(files[i].name)) {
        return false;
      }
      list.push(files[i]);
    }
    return Promise.all(list.map(file => validateImage(file, width, height)));
  },
};

const minAndEqualSize = {
  getMessage(field, [size], data) {
    const sizeNumber = Number(size) / 1024;
    return (data && data.message) || `The ${field} size must be less than or equal to ${sizeNumber} MB`;
  },
  validate(files, [size]) {
    const validateSize = (file, size) => {
      const sizeFile = Math.round(file.size/1024)/1000;
      const sizeNumber = Number(size) / 1024;
      return new Promise((resolve) => {
        resolve({ valid: sizeFile <= sizeNumber });
      });
    };
    return Promise.all(files.map(file => validateSize(file, size)));
  },
};

const maxRowTextArea = {
  getMessage(field, [size]) {
    return `The ${field} field should less than or equal ${size}`
  },
  validate(value, [size]) {
    const valueSplit = value.replace(/^\s+|\s+$|[^\S\r\n]/g,'').replace(/[\r\n]{2,}/g, '\r\n').split(/\r?\n/);
    return valueSplit.length <= size;
  }
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    this.$validator.extend('minimalDimensions', minimalDimensionsRule);
    this.$validator.extend('ratiolDimensions', ratioDimensionsRule);
    this.$validator.extend('minAndEqualSize', minAndEqualSize);
    this.$validator.extend('maxRowTextArea', maxRowTextArea);
    this.$validator.extend('equalDimensions', equalDimensionsRule);
  },
}).$mount('#app');
